<!--  -->
<template>
  <div>
    <el-form
      :label-position="'right'"
      label-width="140px"
    >

      <el-form-item label="来源项目">
        <!-- <el-input v-model="source_project_id" /> -->
        <el-tag
          v-if="source_project_id!=''"
          type="success"
          style="margin-right:10px"
        >{{ source_project_id }}</el-tag>
        <el-button
          size="mini"
          type="primary"
          @click="choosexiamnhmu"
        >选择来源项目</el-button>
      </el-form-item>
      <el-form-item label="来源账户">
        <!-- <el-input v-model="source_account_id" /> -->
        <el-tag
          v-if="source_account_id!=''"
          type="success"
          style="margin-right:10px"
        >{{ source_account_id }}</el-tag>
        <!-- <el-button
          size="mini"
          type="primary"
          @click="chooseiweid"
        >选择来源账户id</el-button> -->
      </el-form-item>
      <el-form-item label="来源项目名称">
        <el-input
          v-model="source_project_name"
          disabled
        />
      </el-form-item>
      <el-form-item label="投放开始时间(天)">
        <span>第 </span>
        <el-input-number
          v-model="start_time"
          :min="1"
          label="投放开始时间(天)"
          style="width:150px"
        />
        <span> 天</span>
      </el-form-item>
      <el-form-item label="投放结束时间(天)">
        <span>第 </span>
        <el-input-number
          v-model="end_time"
          :min="1"
          label="投放结束时间(天)"
          style="width:150px"
        />
        <span> 天</span>
      </el-form-item>
      <el-form-item label="广告状态">
        <el-select
          v-model="opt_status"
          placeholder="请选择类型"
        >
          <el-option
            label="启用"
            :value="'ENABLE'"
          />
          <el-option
            label="暂停"
            :value="'DISABLE'"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="投放产品id">
        <el-input v-model="app_id" />
      </el-form-item>
      <el-form-item label="渠道号">
        <!-- <el-input v-model="mini_app_id" /> -->
        <div v-if="type == 2">已选择：{{ mini_app_namealll }}</div>
        <div style="display:flex;align-items: center;">
          <el-tag v-if="mini_app_idone!=''">{{ mini_app_idemail }}{{ '('+mini_app_idone+')' }}</el-tag>
          <div><el-button
            size="mini"
            type="primary"
            style="margin-left:10px"
            @click="chooseiner"
          >选择账号</el-button></div>
        </div>
        <div
          v-if="mini_app_idone!=''"
          style="display:flex;align-items: center;"
        >
          <el-tag v-if="mini_app_idapp_id!=''">{{ mini_app_ideapp_name }}{{ '('+ mini_app_idapp_id+')' }}</el-tag>
          <div><el-button
            size="mini"
            type="primary"
            style="margin-left:10px"
            @click="sdawer"
          >选择应用</el-button></div>
        </div>
        <div
          v-if="mini_app_idapp_id!=''"
          style="display:flex;align-items: center;"
        >
          <el-tag v-if="mini_app_idwjqw!=''">{{ mini_app_idnick_name }}{{ '('+ mini_app_idwjqw+')' }}</el-tag>
          <div><el-button
            size="mini"
            type="primary"
            style="margin-left:10px"
            @click="dhjalwq"
          >选择渠道号</el-button></div>
        </div>
      </el-form-item>
      <el-form-item label="素材最大数量">
        <div style="display:flex">
          <el-input-number
            v-model="material_num"
            :min="1"
            label="素材数量"
          />
          <el-form-item label="推广章节序号">
            <el-input-number
              v-model="chapter_index"
              :min="1"
              label="推广章节序号"
            />
          </el-form-item>
        </div>

      </el-form-item>
      <el-form-item label="素材最小数量">
        <div style="display:flex">
          <el-input-number
            v-model="material_min"
            :min="1"
            label="素材最小数量"
          />
        </div>
      </el-form-item>

      <el-form-item label="项目预算">
        <el-select
          v-model="budget_mode"
          placeholder="请选择项目预算"
          @change="jdawq"
        >
          <el-option
            label="有限"
            :value="0"
          />
          <el-option
            label="无限"
            :value="-1"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="budget_mode == 0"
        label="预算金额（元）"
      >
        <div style="display:flex">
          <el-input-number
            v-model="budget"
            :min="0"
            label="预算金额（元）"
          />

        </div>
      </el-form-item>
      <el-form-item label="出价系数">
        <el-input-number
          v-model="search_bid_ratio"
          :precision="2"
          :step="0.1"
          :min="0"
          label="出价系数"
        />
      </el-form-item>
      <el-form-item label="状态">
        <el-radio-group v-model="status">
          <el-radio-button
            v-for="city in corp_allids"
            :key="city.corp_id"
            :label="city.corp_id"
          >
            {{ city.corp_name }}
          </el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="remark" />
      </el-form-item>
      <el-form-item label="目标项目名称">
        <el-input v-model="target_name" />
      </el-form-item>
      <el-form-item label="请选择账户">
        <el-button @click="chorwer">选择广告主</el-button>
        <el-tag
          v-for="item,index in selectedAccounts"
          :key="index"
          closable
          style="margin-left: 10px"
          @close="removeAccount(index)"
        >{{ item.account_id }}</el-tag>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="sumbitr"
        >确定</el-button>
      </el-form-item>
    </el-form>
    <el-dialog
      title="选择人员"
      :visible.sync="dialogVisibleaccr"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="40%"
    >
      <!-- :destroy-on-close="true" -->
      <MyDialog
        ref="bandaccountview"
        @bandarr="bandarrview"
      />
    </el-dialog>
    <el-dialog
      title="来源账户ID"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <!-- :destroy-on-close="true" -->
      <liewid
        ref="liewidview"
        @callback="callback"
      />
    </el-dialog>
    <el-dialog
      title="来源项目ID"
      :visible.sync="dialogVisiblexiangmu"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="60%"
    >
      <!-- :destroy-on-close="true" -->
      <xiangmu
        ref="xiangmuview"
        @callbackr="callbackr"
      />
    </el-dialog>
    <el-dialog
      title="选择"
      :visible.sync="dialogVisibleone"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="30%"
    >
      <div style="display: flex;align-items: center;margin-bottom:10px">
        <el-input
          v-model="email"
          placeholder="请输入内容"
          style="width:200px"
        />
        <el-button
          style="margin-left:10px"
          type="primary"
          @click="serahrw"
        >搜索</el-button>
      </div>
      <el-table
        :data="tableDataone"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="email"
          label="邮箱"
          width="180"
          align="center"
        />
        <el-table-column
          prop="id"
          label="ID"
          width="180"
          align="center"
        />
        <el-table-column
          prop="id"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="choose(scope.row)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="选择"
      :visible.sync="dialogVisibletwo"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="30%"
    >
      <div style="display: flex;align-items: center;margin-bottom:10px">
        <el-input
          v-model="app_name"
          placeholder="请输入内容"
          style="width:200px"
        />
        <el-button
          style="margin-left:10px"
          type="primary"
          @click="serahrwweqw"
        >搜索</el-button>
      </div>
      <el-table
        :data="tableDatatwo"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="app_name"
          label="app_name"
          width="180"
          align="center"
        />
        <el-table-column
          prop="app_id"
          label="app_id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="id"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="chooseonwe(scope.row)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-dialog
      title="选择"
      :visible.sync="dialogVisiblethree"
      :append-to-body="true"
      :close-on-click-modal="false"
      width="30%"
    >
      <!-- <div style="display: flex;align-items: center;margin-bottom:10px">
        <el-input
          v-model="app_name"
          placeholder="请输入内容"
          style="width:200px"
        />
        <el-button
          style="margin-left:10px"
          type="primary"
          @click="serahrwweqw"
        >搜索</el-button>
      </div> -->
      <el-table
        :data="tableDatathree"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="nick_name"
          label="nick_name"
          width="180"
          align="center"
        />
        <el-table-column
          prop="id"
          label="id"
          width="180"
          align="center"
        />
        <el-table-column
          prop="id"
          label="操作"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click="chooseodadq(scope.row)"
            >选择</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { createadconfigcreate, createadconfigupdate, playletaccountlistonewqww, playletaccountlisttwo, playletaccountlistthree } from '@/api/report/adx'
import MyDialog from './MyDialog.vue'
import liewid from './liewid.vue'
import xiangmu from './xiangmu.vue'
export default {
  components: { MyDialog, liewid, xiangmu },
  data() {
    return {
      dialogVisibleaccr: false,
      dialogVisible: false,
      dialogVisiblexiangmu: false,
      type: null,
      id: null,
      source_account_id: '',
      source_project_id: '',
      source_project_name: '',
      start_time: '',
      end_time: '',
      opt_status: 'ENABLE',
      app_id: '',
      material_num: '',
      material_min: '',
      mini_app_id: '',
      chapter_index: '',
      budget_mode: 0,
      budget: 0,
      search_bid_ratio: '',
      remark: '',
      target_name: '',
      selectedAccounts: [],
      status: 1,
      newselectedAccounts: [],
      corp_allids: [
        {
          corp_name: '开启',
          corp_id: 1
        },
        {
          corp_name: '关闭',
          corp_id: 2
        }
      ],
      email: '',
      dialogVisibleone: false,
      tableDataone: [],
      mini_app_idone: '',
      mini_app_idemail: '',

      dialogVisibletwo: false,
      tableDatatwo: [],
      app_name: '',
      mini_app_idapp_id: '',
      mini_app_ideapp_name: '',
      mini_app_idaccount_id: '',

      dialogVisiblethree: false,
      tableDatathree: [],
      mini_app_idnick_name: '',

      mini_app_namealll: '',
      mini_app_idwjqw: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    send(type, item) {
      this.type = type
      if (type !== 1) {
        this.source_account_id = item.source_account_id
        this.source_project_id = item.source_project_id
        this.source_project_name = item.source_project_name
        this.start_time = item.start_time
        this.end_time = item.end_time
        this.opt_status = item.opt_status
        this.app_id = item.app_id
        this.material_num = item.material_num
        this.material_min = item.material_min
        this.mini_app_id = item.mini_app_id
        this.chapter_index = item.chapter_index
        this.budget_mode = item.budget_mode
        this.budget = item.budget
        this.search_bid_ratio = item.search_bid_ratio
        this.remark = item.remark
        this.target_name = item.target_name
        this.status = item.status
        this.selectedAccounts = item.account_ids.map(id => ({ account_id: id }))
        this.mini_app_namealll = item.mini_app_name
      }
      if (type === 2) {
        this.id = item.id
      }
    },
    chorwer() {
      this.dialogVisibleaccr = true
      this.$nextTick(() => {
        this.$refs.bandaccountview.sendr(this.selectedAccounts)
      })
    },
    bandarrview(arr) {
      this.dialogVisibleaccr = false
      this.selectedAccounts = arr
    },
    removeAccount(index) {
      this.selectedAccounts.splice(index, 1)
    },
    async sumbitr() {
      if (this.source_project_id === '') {
        this.$message.error('请选择来源项目')
        return
      }
      if (this.source_account_id === '') {
        this.$message.error('请选择来源账户ID')
        return
      }
      if (this.source_project_name === '') {
        this.$message.error('请输入来源项目名称')
        return
      }
      if (this.start_time === '') {
        this.$message.error('请输入投放开始时间')
        return
      }
      if (this.end_time === '') {
        this.$message.error('请输入投放结束时间')
        return
      }
      if (this.app_id === '') {
        this.$message.error('请输入投放产品id')
        return
      }
      if (this.material_num === '') {
        this.$message.error('请输入素材最大数量')
        return
      }
      if (this.material_min === '') {
        this.$message.error('请输入素材最小数量')
        return
      }
      if (this.material_num < this.material_min) {
        return this.$message.error('请输入正确的素材数量（最大数量不能小于最小数量）')
      }
      if (this.mini_app_id === '') {
        this.$message.error('请输入字节小程序appid')
        return
      }
      if (this.chapter_index === '') {
        this.$message.error('请输入推广章节序号')
        return
      }
      // eslint-disable-next-line eqeqeq
      if (this.budget_mode == 0) {
        if (this.budget === 0) {
          this.$message.error('请输入预算金额')
          return
        }
      }
      if (this.search_bid_ratio === '') {
        this.$message.error('请输入出价系数')
        return
      }
      if (this.remark === '') {
        this.$message.error('请输入备注')
        return
      }

      this.newselectedAccounts = []
      this.newselectedAccounts = this.selectedAccounts.map(item => {
        return item.account_id
      })
      if (this.type !== 2) {
        const data = await createadconfigcreate({
          source_account_id: this.source_account_id,
          source_project_id: this.source_project_id,
          source_project_name: this.source_project_name,
          start_time: this.start_time,
          end_time: this.end_time,
          opt_status: this.opt_status,
          app_id: this.app_id,
          material_num: this.material_num,
          material_min: this.material_min,
          mini_app_id: this.mini_app_id,
          chapter_index: this.chapter_index,
          budget_mode: this.budget_mode,
          budget: this.budget,
          search_bid_ratio: this.search_bid_ratio,
          remark: this.remark,
          account_ids: this.newselectedAccounts,
          target_name: this.target_name,
          status: this.status
        })
        this.$message({
          message: '添加成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      } else {
        const data = await createadconfigupdate({
          id: this.id,
          source_account_id: this.source_account_id,
          source_project_id: this.source_project_id,
          source_project_name: this.source_project_name,
          start_time: this.start_time,
          end_time: this.end_time,
          opt_status: this.opt_status,
          app_id: this.app_id,
          material_num: this.material_num,
          material_min: this.material_min,
          mini_app_id: this.mini_app_id,
          chapter_index: this.chapter_index,
          budget_mode: this.budget_mode,
          budget: this.budget,
          search_bid_ratio: this.search_bid_ratio,
          remark: this.remark,
          account_ids: this.newselectedAccounts,
          target_name: this.target_name,
          status: this.status
        })
        this.$message({
          message: '修改成功',
          type: 'success'
        })
        this.$emit('updatawe')
        console.log('data', data)
      }
    },
    chooseiweid() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.liewidview.send()
      })
    },
    callback(item) {
      console.log(item)
      this.dialogVisible = false
      this.source_account_id = item.account_id
    },
    choosexiamnhmu() {
      this.dialogVisiblexiangmu = true
      this.$nextTick(() => {
        this.$refs.xiangmuview.send()
      })
    },
    callbackr(item) {
      console.log(item)
      this.dialogVisiblexiangmu = false
      this.source_project_id = item.project_id
      this.source_project_name = item.name
      this.source_account_id = item.account_id
    },
    jdawq(val) {
      console.log(val)
      if (val === -1) {
        this.budget = 0
      }
    },
    choose(item) {
      this.dialogVisibleone = false
      this.mini_app_idone = item.id
      this.mini_app_idemail = item.email
      console.log('item', item)
    },
    chooseiner() {
      this.dialogVisibleone = true
      playletaccountlistonewqww({
        email: this.email
      }).then(res => {
        console.log('res', res)
        this.tableDataone = res.data.list
      })
    },
    serahrw() {
      playletaccountlistonewqww({
        email: this.email
      }).then(res => {
        console.log('res', res)
        this.tableDataone = res.data.list
      })
    },
    sdawer() {
      this.dialogVisibletwo = true
      playletaccountlisttwo({
        account_id: this.mini_app_idone,
        app_name: this.app_name
      }).then(res => {
        console.log('res', res)
        this.tableDatatwo = res.data.list
      })
    },
    serahrwweqw() {
      this.dialogVisibletwo = true
      playletaccountlisttwo({
        account_id: this.mini_app_idone,
        app_name: this.app_name
      }).then(res => {
        console.log('res', res)
        this.tableDatatwo = res.data.list
      })
    },
    chooseonwe(item) {
      this.dialogVisibletwo = false
      this.mini_app_idapp_id = item.app_id
      this.mini_app_ideapp_name = item.app_name
      this.mini_app_idaccount_id = item.account_id
    },
    dhjalwq() {
      this.dialogVisiblethree = true
      playletaccountlistthree({
        account_id: this.mini_app_idaccount_id,
        app_id: this.mini_app_idapp_id
      }).then(res => {
        console.log('res', res)
        this.tableDatathree = res.data.list
      })
    },
    chooseodadq(item) {
      this.dialogVisiblethree = false
      this.mini_app_id = item.id
      this.mini_app_idwjqw = item.id
      this.mini_app_idnick_name = item.nick_name

      this.mini_app_namealll = this.mini_app_ideapp_name + '-' + item.nick_name
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
